import React, { PropTypes } from 'react';
import $ from 'jquery';
import cx from 'classnames';

const Image = ({ src, onDelete }) => (
  <div className="ui cards">
    <div className="card">
      <img src={src} alt="Contenu message" />
      <button className="ui bottom attached button" onClick={onDelete}>
        <i className="close icon" />
        Supprimer
      </button>
    </div>
  </div>
);

Image.propTypes = {
  src: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

// TODO: add multiline support
export default class NewMessageBar extends React.Component {
  static propTypes = {
    canSend: PropTypes.bool,
    isSending: PropTypes.bool.isRequired,
    onSend: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canSend: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      content: '',
    };

    this.onKeyboardPressed = this.onKeyboardPressed.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSelectImage = this.onSelectImage.bind(this);
    this.imageSelected = this.imageSelected.bind(this);
    this.imageDeleted = this.imageDeleted.bind(this);
    this.onSend = this.onSend.bind(this);
  }

  onChange(evt) {
    const content = evt.target.value;
    this.setState({
      content,
    });
  }

  onSelectImage() {
    $(this.refs.image).trigger('click');
  }

  imageSelected(evt) {
    const image = evt.target.files[0];
    if (image) {
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          this.setState({
            image,
            thumbnail: reader.result,
          });
        },
        false
      );

      reader.readAsDataURL(image);
    }
  }

  imageDeleted() {
    this.setState({
      image: undefined,
      thumbnail: undefined,
    });
  }

  onKeyboardPressed(evt) {
    // // Allow event pooling
    // evt.persist()
    //
    // const { keyCode, shiftKey } = evt
    // if (keyCode === 13 && !shiftKey) { // Enter pressed, sending message
    //   this.onSend()
    // }

    const { keyCode } = evt;
    if (keyCode === 13) {
      // Enter pressed, sending message
      this.onSend();
    }
  }

  onSend() {
    const { content, image } = this.state;
    if (content || image) {
      this.props.onSend({
        content,
        image,
      });
      this.setState({
        content: '',
        image: undefined,
        thumbnail: undefined,
      });
    }
  }

  render() {
    const { canSend, isSending } = this.props;
    const { content, thumbnail } = this.state;

    const sendClass = cx('ui primary button', {
      disabled: (!content && !thumbnail) || !canSend,
      loading: isSending,
    });

    return (
      <div className="ui segment extra">
        <input
          type="file"
          ref="image"
          style={{ display: 'none' }}
          onChange={this.imageSelected}
        />
        <div className="ui action input">
          <input
            type="text"
            placeholder="Message ..."
            value={content}
            onChange={this.onChange}
            onKeyUp={this.onKeyboardPressed}
          />
          {!!thumbnail || (
            <button className="ui button" onClick={this.onSelectImage}>
              <i className="attach icon" />
            </button>
          )}
          {thumbnail && <Image src={thumbnail} onDelete={this.imageDeleted} />}
          <button className={sendClass} onClick={this.onSend}>
            <i className="send icon" />
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/components/NewMessageBar.js